import { render, staticRenderFns } from "./sortingProgress.vue?vue&type=template&id=25a96b04&scoped=true"
import script from "./sortingProgress.vue?vue&type=script&lang=js"
export * from "./sortingProgress.vue?vue&type=script&lang=js"
import style0 from "./sortingProgress.vue?vue&type=style&index=0&id=25a96b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a96b04",
  null
  
)

export default component.exports